import { AccountMarketer, Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export class AccountMarketerService extends BaseService {
  private marketerApi = "accountMarketers";

  async getMarketers(params: {
    id?: number;
    name?: string;
    pageIndex?: number;
    recordCount?: number;
  }): Promise<Result<AccountMarketer[]>> {
    return this.get(`${this.marketerApi}`, params);
  }

  async getMarketer(id: number): Promise<Result<AccountMarketer>> {
    return this.get(`${this.marketerApi}/${id}`);
  }

  async addOrUpdateMarkter(
    params: {
      name: string;
    },
    id?: number
  ): Promise<Result<AccountMarketer | boolean>> {
    if (id) {
      return this.put(`${this.marketerApi}/${id}`, params.name);
    } else {
      return this.post(`${this.marketerApi}`, params.name);
    }
  }

  async deleteMarketer(id: number): Promise<Result<boolean>> {
    return this.delete(`${this.marketerApi}/${id}`);
  }
}

export default new AccountMarketerService();
